module.exports = __webpack_public_path__ + "static/media/Photo-Album.6fdffa9a.png";